import { links } from "../../utils/links";

export default function SocialLinks() {
  return (
    <div className="social-icons p-0 m-0 h-0 row">
      <ul className="hidden-xs">
        {/* <li>
          <a
            title="Go Out"
            href="/RequestGoout"
            className="link-tel link-tel--light"
          >
            <i className="sprite sprite-goout_25x25"></i>
          </a>
        </li> */}
        <li>
          <a
            className="link-tel link-tel--light"
            href={links.whatsapp}
            title="Chat Now"
          >
            <i className="sprite sprite-chat25x25"></i>
          </a>
        </li>
      </ul>
      <ul className="visible-xs">
        {/* <li>
          <a href="/Goout" title="Go Out" className="link-tel link-tel--light">
            <i className="sprite sprite-goout_40x40"></i>
          </a>
        </li> */}
        <li>
          <a
            className="link-tel link-tel--light"
            title="Chat Now"
            href={links.whatsapp}
          >
            <i className="sprite sprite-chat40x40"></i>
          </a>
        </li>
      </ul>
    </div>
  );
}
